import { KeyCombo, KeyAlias } from '@tabeeb/uikit/hooks/useHotkey'
import { isMacOs } from 'react-device-detect'

const controlLabel: KeyAlias = isMacOs ? 'Control' : 'Ctrl'

export const ToggleMicrophone: KeyCombo = [controlLabel, 'Shift', 'M']
export const ToggleCamera: KeyCombo = [controlLabel, 'Shift', 'V']
